import React, { useEffect, useState } from "react";

import Form from "./Form";
import Loader from "../../general/Loader";
import { apiRequest } from "../../../hooks/apiRequest";
import { request } from "../../../utils/request";
import { toast } from "../../../utils/helpers";
import Modal from "../../general/Modal";

const Edit = ({ toggleModal, getUnidadesData, unidadID }) => {
	const [saving, setSaving] = useState(false);
	const [errors, setErrors] = useState({});
	const [unidad, setUnidad] = useState({});
	const [showDelete, setShowDelete] = useState(false);

	const getUnidadData = () => {
		if (!unidadID) return;

		request(`unidades/${unidadID}`).then((res) => {
			setUnidad(res.data);
		});
	};

	const updateUnidad = (event) => {
		event.preventDefault();
		setSaving(true);
		const data = new FormData(event.target);

		apiRequest(data, `unidades/${unidad.id}`, "post").then((response) => {
			if (response.success) {
				getUnidadesData();
				toggleModal();
				setSaving(false);
				toast("Unidad actualizada.");
			}
			if (response.code === 422) {
				setErrors({
					...response.data.message,
				});
				setSaving(false);
			}
		});
	};

	const deleteUnidad = () => {
		apiRequest(null, `unidades/${unidad.id}`, "delete").then((response) => {
			if (response.success) {
				getUnidadesData();
				toggleModal();
				toast("Unidad eliminada.");
				return;
			}
			if (response.code === 422) {
				toast(
					response.data.message ||
						"No se puede borrar: la unidad está en uso.",
					"error"
				);
			}
			setShowDelete(false);
		});
	};

	const toggleDeleteModal = () => {
		setShowDelete((state) => !state);
	};

	useEffect(() => {
		getUnidadData();
	}, [unidadID]);

	return (
		<>
			<form id="unidadEditForm" method="post" onSubmit={updateUnidad}>
				<input type="hidden" name="_method" value="put" />
				<div className="popup__header">Editar Unidad</div>

				{!unidadID ? <Loader /> : <Form unidad={unidad} errors={errors} />}

				<div className="popup__footer">
					<button
						type="button"
						className="btn float-left"
						onClick={() => toggleDeleteModal()}
					>
						<i className="fas fa-trash-alt"></i>
					</button>
					<button
						type="button"
						className="btn btn-plain"
						onClick={() => toggleModal()}
					>
						Cancelar
					</button>
					{saving ? (
						<Loader type="small" />
					) : (
						<button type="submit" className="btn btn-primary">
							Editar
						</button>
					)}
				</div>
			</form>
			<Modal
				title="Borrar Unidad"
				show={showDelete}
				callback={() => deleteUnidad()}
				acceptText="Borrar"
				toggle={toggleDeleteModal}
			>
				¿Estás seguro de que deseas borrar esta unidad? Si algún producto la
				usa, no se podrá borrar — desactívala en su lugar.
			</Modal>
		</>
	);
};

export default Edit;
